import { render, staticRenderFns } from "./ModifyImmediateDiscount.vue?vue&type=template&id=23dac178&"
import script from "./ModifyImmediateDiscount.vue?vue&type=script&lang=ts&"
export * from "./ModifyImmediateDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports